// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__LR1mX","title":"styles_title__vJN-r"};